import { HandCoins, QrCode, Wallet } from "lucide-react";

import { Logo } from "@/core/components/layout/logo";
import { ModeToggle } from "@/core/components/layout/mode-toggle";
import { AppVersionLabel } from "@/core/components/shared";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { ForgotPasswordForm } from "@/features/auth/components/forgot-password-form";

/**
 * Page publique `/forgot-password` (mode password, guide API v1.3) :
 * coquille split-screen identique à `/login` — panneau branding à gauche,
 * formulaire de demande de réinitialisation à droite, animation gif en aside.
 */
export function ForgotPasswordPage() {
  const { t } = useTypedTranslation();

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Panneau gauche — logo, textes branding et formulaire sur fond blanc.
          text-foreground explicite : le GuestLayout parent hérite d'un
          texte clair (brand-50) prévu pour fond foncé. */}
      <main className="flex min-h-screen min-w-0 flex-col bg-background px-4 py-8 text-foreground sm:px-10">
        <div className="flex items-center justify-between gap-4">
          <Logo />
          <ModeToggle />
        </div>
        <h1 className="mt-6 max-w-md text-2xl font-bold leading-tight text-foreground">
          {t("auth.forgotPassword.title")}
        </h1>
        {/* Formulaire centré dans l'espace disponible. */}
        <div className="flex flex-1 flex-col items-center justify-center py-8">
          <ForgotPasswordForm />
          <AppVersionLabel className="mt-4 text-center" />
        </div>
        {/* Points produit + mention, en bas de page. */}
        <div className="flex flex-col gap-6">
          <ul className="flex flex-col gap-4 text-muted-foreground sm:flex-row sm:flex-wrap sm:gap-x-6">
            <li className="flex items-center gap-3">
              <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-gradient-accent text-brand-950">
                <Wallet className="size-4" />
              </span>
              {t("auth.login.brand.point.wallet")}
            </li>
            <li className="flex items-center gap-3">
              <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-gradient-accent text-brand-950">
                <QrCode className="size-4" />
              </span>
              {t("auth.login.brand.point.qr")}
            </li>
            <li className="flex items-center gap-3">
              <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-gradient-accent text-brand-950">
                <HandCoins className="size-4" />
              </span>
              {t("auth.login.brand.point.payroll")}
            </li>
          </ul>
          <p className="text-sm text-muted-foreground">
            {t("auth.login.brand.caption")}
          </p>
        </div>
      </main>

      {/* Panneau droit — animation gif seule, masquée sur mobile. */}
      <aside className="relative hidden overflow-hidden bg-brand-950 lg:block">
        <img
          src="/1.gif"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </aside>
    </div>
  );
}
